module.exports = __webpack_public_path__ + "img/logo.2ef22ed3.svg";